import { ApiException, ProblemDetails } from './mceapi.client.generated';
import { Option, fold, match, none, some } from '../shared/functions/functional';

// This is what we expect from (to) the api.
type OptionDto<T> = {
  isSome: boolean;
  isNone: boolean;
  value: T[];
};

// convert any DTO option from the api to an option
export function apiOptionDtoToOption<T>(dto?: { isSome?: boolean; isNone?: boolean; value?: T[]; } | null
): Option<T> {
  if (dto?.isSome && dto.value && dto.value.length > 0) {
    return some(dto.value[0]);
  }
  return none;
}

// export function apiOptionDtoToOption1<T>(dto: { isSome: boolean; isNone: boolean; value?: T[] } | Record<string, any>): Option<T> {
//   if (dto.isSome && dto.value && dto.value.length > 0) {
//     return some(dto.value[0]);
//   } else {
//     return none;
//   }
// }
export const appOpt = apiOptionDtoToOption;

// convert from a option to api option DTO
export function optionToApiOptionDto<T>(fpTsOption: Option<T>): { isSome: boolean; isNone: boolean; value: T[] } {
  return fold<T, { isSome: boolean; isNone: boolean; value: T[] }>(
    () => ({ isSome: false, isNone: true, value: [] }),
    (value) => ({ isSome: true, isNone: false, value: [value] })
  )(fpTsOption);
}
export const apiOpt = optionToApiOptionDto;
export const apiOptSome = <T>(value: T) => optionToApiOptionDto(some(value));

export function isSomeOptionDto(option: any)
{ return option.isSome && option.value && option.value.length > 0; }
export function isNoneOptionDto(option: any) { return !isSomeOptionDto(option); }

export function getNoneOptionDto<T>(): { isSome: false; isNone: true; value: T[]; } {
  return { isSome: false, isNone: true, value: [] };
}
export const apiOptNone = getNoneOptionDto; 

export function getSomeOptionDto<T>(value: T): { isSome: true; isNone: false; value: T[]; } {
  return { isSome: true, isNone: false, value: [value] };
}

export function getApiErrorMessage(error: unknown): string {
  if (ApiException.isApiException(error)) {
    const problemDetails = getProblemDetails(error);
    const validationErrors = problemDetails?.['errors'];

    if (validationErrors && typeof validationErrors === 'object') {
      const messages = Object.values(validationErrors)
        .flatMap(value => Array.isArray(value) ? value : [value])
        .filter((value): value is string => typeof value === 'string' && value.length > 0);

      if (messages.length > 0) {
        return messages.join('\n');
      }
    }

    return problemDetails?.detail
      ?? problemDetails?.title
      ?? getResponseMessage(error.response)
      ?? error.message;
  }

  return error instanceof Error ? error.message : 'An unexpected error occurred.';
}

function getResponseMessage(response: string): string | undefined {
  if (!response) {
    return undefined;
  }

  try {
    const parsed = JSON.parse(response);
    return typeof parsed === 'string' ? parsed : response;
  }
  catch {
    return response;
  }
}

function getProblemDetails(error: ApiException): ProblemDetails | undefined {
  if (error.result && typeof error.result === 'object') {
    return error.result as ProblemDetails;
  }

  if (!error.response) {
    return undefined;
  }

  try {
    return JSON.parse(error.response) as ProblemDetails;
  }
  catch {
    return undefined;
  }
}




